export default {
	state: {
    is_logged_in: false,
    dashboard_greeting: '',
    session_exp: null,
  },

  user: {
    data: []
  },

  permissions: {
    module_access: [],
    user_roles: []
  },
};


// WEBPACK FOOTER //
// ./src/store/Store.js